import { ajax, AjaxResponse } from 'rxjs/ajax';
import { Observable } from 'rxjs';
import Provider from './api.types';
import { Interceptors } from '../interceptors/interceptors.provider';

class ApiProvider implements Provider {
  constructor(
    public baseUrl: string = String(
      import.meta.env.VITE_APP_SERVER_URL as string,
    ),
    private readonly interceptors = new Interceptors(),
  ) {}

  private isAbsoluteUrl = (url: string): boolean => {
    const path = /^https?:\/\//i;
    return path.test(url);
  };

  private getUrl = (url: string) => {
    if (this.isAbsoluteUrl(url)) return url;
    return `${this.baseUrl}/${url}`;
  };

  get = <T>(
    url: string,
    headers?: Record<string, string>,
    queryParams?: Record<string, any>,
  ): Observable<AjaxResponse<T>> => {
    return this.interceptors.executeRequest({
      url: this.getUrl(url),
      method: 'GET',
      headers,
      queryParams,
    });
  };

  getJSON = <T>(url: string, headers?: Record<string, string>): Observable<T> =>
    ajax.getJSON(this.getUrl(url), headers);

  post = <T>(
    url: string,
    body: any,
    headers?: Record<string, string>,
  ): Observable<AjaxResponse<T>> =>
    this.interceptors.executeRequest({
      url: this.getUrl(url),
      method: 'POST',
      body,
      headers,
    });

  put = <T>(
    url: string,
    body: any,
    headers?: Record<string, string>,
  ): Observable<AjaxResponse<T>> =>
    this.interceptors.executeRequest({
      url: this.getUrl(url),
      method: 'PUT',
      body,
      headers,
    });

  patch = <T>(
    url: string,
    body: any,
    headers?: Record<string, string>,
  ): Observable<AjaxResponse<T>> =>
    this.interceptors.executeRequest({
      url: this.getUrl(url),
      method: 'PATCH',
      body,
      headers,
    });

  delete = <T>(
    url: string,
    headers?: Record<string, string>,
  ): Observable<AjaxResponse<T>> =>
    this.interceptors.executeRequest({
      url: this.getUrl(url),
      method: 'DELETE',
      headers,
    });

  setBaseUrl = (url: string) => {
    this.baseUrl = url;
  };
}

export default ApiProvider;
